import { FileText } from 'lucide-react';
import { z } from 'zod';

import { useGetArtifactQuery } from '@/services/api/artifactService';

import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';
import { useMaybeParseValues } from './utils';

// Accept both old format (target_id) and new format (file_id)
const ReadFileOrTranscriptArgsSchema = z
  .object({
    explanation: z.string(),
    file_id: z.string().optional(),
    target_id: z.string().optional(),
    artifact_id: z.string().optional(),
  })
  .refine((data) => data.file_id || data.target_id, {
    message: 'Either file_id or target_id must be provided',
  });

export const ReadFileOrTranscriptBadge = ({
  isDone,
  ...props
}: BaseToolBadgeProps) => {
  const allProps = { ...props, isDone };

  const args = useMaybeParseValues(ReadFileOrTranscriptArgsSchema, [
    props.toolMessage?.additional_kwargs?.artifact_info,
    props.args,
  ]);

  const { data: artifact } = useGetArtifactQuery(
    {
      matterId: props.matterId,
      artifactId: args?.artifact_id ?? 'not-found',
    },
    {
      skip: !args?.artifact_id,
    },
  );

  // Get the file identifier (either format)
  const fileIdentifier =
    artifact?.name || args?.file_id || args?.target_id || 'file';

  return (
    <BaseBadge
      {...allProps}
      showArgs={false}
      icon={FileText}
      resultTexts={{
        loading: 'Reading content...',
        done: `Read ${fileIdentifier}`,
        error: 'Error reading content',
      }}
    />
  );
};
